import { createFileRoute } from '@tanstack/react-router';
import { AudioPage } from '@/components/astro/pages/audio';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/youtube')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Convert Academic Text to Audio',
        description:
          'Stream academic papers on the go with our app and save valuable time. Experience it firsthand—try now on our YouTube channel now!',
      }),
    ],
  }),
  component: AudioPage,
});
